import { SrtFormValues } from '../types';

export const syncInterviewDates = (values: SrtFormValues): SrtFormValues => ({
    ...values,
    entrevistados: (values.entrevistados || []).map((row: Record<string, any>) => ({
        ...row,
        fecha: values.responsableFecha || ''
    }))
});